/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var lastScrollTop = 0;
  var search_tooltip_timeout = null;

  function watchNavigationScroll(e) {
    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  $.fn.extend({
    print: function() {
      var frameName = 'printIframe';
      var doc = window.frames[frameName];
      if (!doc) {
        $('<iframe>').hide().attr('name', frameName).appendTo(document.body);
        doc = window.frames[frameName];
      }
      doc.document.body.innerHTML = this.html();
      doc.window.print();
      return this;
    }
  });

  function showSearchForm() {
    $('#search-wrapper').addClass('visible');
    
    $('#search-wrapper #s').focus();
    
    setTimeout(function() {
      $('.search-close').tooltip('show');
    }, 1000);
    
    search_tooltip_timeout = setTimeout(function() {
      $('.search-close').tooltip('hide');
    }, 3000);
  }
  
  function hideSearchForm() {
    clearTimeout(search_tooltip_timeout);
    
    $('.search-close').tooltip('hide');
    
    $('#search-wrapper').removeClass('visible');
  }

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('#navigation').on('show.bs.collapse', function() {
          $('body').addClass('nav-on');
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('nav-on');
        });

        $('body').addClass('dom-loaded');

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        var wow = new WOW(
          {
            boxClass: 'wow',      // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 70,          // distance to the element when triggering the animation (default is 0)
            mobile: true,       // trigger animations on mobile devices (default is true)
            live: true,       // act on asynchronously loaded content (default is true)
            callback: function (box) {
              $(box).addClass('appeared');
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
          }
        );
        wow.init();

        $(document).on('show.bs.collapse', '.form-group .collapse', function() {
          $(this).closest('.form-group').addClass('dropdown-open');

          $('.form-group .collapse').not( $(this) ).collapse('hide');
        });

        $(document).on('hidden.bs.collapse', '.form-group .collapse', function() {
          $(this).closest('.form-group').removeClass('dropdown-open');
        });

        if( $('.directory-search-form').length ) {
          $(document).on('click', function(e) {
            if( !$(e.target).closest('.dropdown-wrapper').length ) {
              $('.directory-search-form').find('.collapse').collapse('hide');
            }
          });
        }

        $(document).on('click', '.custom-checkbox input', function() {
          var group = $(this).closest('.form-group');
          var selected_options = [];

          group.find('input:checked').each(function() {
            selected_options.push( $(this).siblings('label').text() );
          });

          group.find('.selected-text').text( selected_options.join(', ') );
        });

        $(document).on('reset', 'form', function() {
          $(this).find('.selected-text').text('');
        });

        $('[data-bs-toggle="tooltip"]').tooltip();
        
        $('.search-toggle').on('click', function(e) {
          e.preventDefault();
          showSearchForm();
        });

        $('.search-close').on('click', function(e) {
          e.preventDefault();
          hideSearchForm();
        });
        
        $(document).keyup(function(e) {
          if (e.keyCode === 27) {
            hideSearchForm();
          }
        });

        $(document).on('click', '.print-user', function(e) {
          e.preventDefault();

          $('#directory-details').print();
        });

        watchSlickDots();

        $(window).on('resize', function() {
          watchSlickDots();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
